// extracted by mini-css-extract-plugin
export default {"wrapper":"PlaygroundEmpty_wrapper__uoW5p"};